/* eslint-disable react-hooks/rules-of-hooks */
import { useCallback, useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'

import type { BasePickerProps } from '../../typings/BasePicker'

export function useOpenState({ open, onOpen, onClose }: BasePickerProps) {
  let setIsOpenState: null | Dispatch<SetStateAction<boolean>> = null
  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    // eslint-disable-next-line no-param-reassign
    ;[open, setIsOpenState] = useState<boolean>(false)
  }

  // prettier-ignore
  const setIsOpen = useCallback((newIsOpen: boolean) => {
    if (setIsOpenState) {
      setIsOpenState(newIsOpen)
    }

    if (newIsOpen) {
      return onOpen?.()
    }

    return onClose?.()
  }, [onOpen, onClose, setIsOpenState])

  return { isOpen: open, setIsOpen }
}
